<template>
    <div v-if="state">
        <a
            v-for="item in state.items"
            :key="item.value"
            class="block py-2 last:pb-0 px-4 border-b border-grey-200 last:border-b-0 text-sm text-grey-300"
            @click="
                state.refine(item.value);
                closeCategories();
            "
        >
            <div class="flex flex items-center justify-between w-full">
                <span class="block whitespace-no-wrap uppercase font-normal text-black">
                    {{ item.label }}
                </span>
                <div
                    v-if="currentlyRefined(item.label)"
                    class="border border-ochre-500 rounded-full w-4 h-4 flex justify-center items-center"
                >
                    <div class="w-2 h-2 bg-yellow-500 rounded-full"></div>
                </div>
                <div
                    v-else
                    class="border rounded-full w-4 h-4 flex justify-center items-center"
                ></div>
            </div>
        </a>
    </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectMenu } from 'instantsearch.js/es/connectors';

export default {
    mixins: [createWidgetMixin({ connector: connectMenu })],
    computed: {
        widgetParams() {
            return {
                attribute: 'roam_products_regions.lvl0'
            };
        }
    },
    methods: {
        closeCategories() {
            document.querySelector('html').classList.remove('ais-Search-categories-active');
        },
        currentlyRefined(label) {
            const match = this.state.items.find((item) => item.label === label);
            let isRefined = match ? match.isRefined : false;
            return isRefined;
        }
    }
};
</script>
